import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import RentIconBlue from '../../../../../assets/images/module/general/RentIcon.svg';
import ReceiptsIcon from '../../../../../assets/images/module/general/ReceiptsIconGray.svg';
import RentIcon from '../../../../../assets/images/module/general/RentIconGray.svg';
import ReceiptsIconBlue from '../../../../../assets/images/module/general/ReceiptsIconBlue.svg';
import Up from '../../../../../assets/images/module/general/SelectArrowUp.svg';
import Down from '../../../../../assets/images/module/general/SelectArrowDown.svg';
import { Checkbox, CloseButton, Group, Loader, MultiSelect, Radio, RadioGroup, SimpleGrid, Stack, TextInput, Select, Menu } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';
import CardSelection from '../CardSelection/CardSelection';
import Autoload from '../../../../Autoload';
import { connect } from 'react-redux';
import LaunchIcon from '@material-ui/icons/Launch';
import TruncatedTextHandler from '../../../../../components/TruncatedTextHandler';
import { IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ReceiptDetailModal from './ReceiptDetailModal';
import ShowModal from './ShowModal';
import ImageModal from './ImageModal';
import SelectReceiptsForTransactionAssigmentModal from './SelectReceiptsForTransactionAssigmentModal';
import dayjs from 'dayjs';
import SwitchContainer from '../SwitchContainer';
import GlobalServices from '../../../../helpers/services/GlobalServices';
import TenantDataHandler from '../../../../helpers/DataHandler/Tenant';

// Import our new Drop-In Component!
import CustomMultiSelect from '../../../Module/General/CustomMultiSelect/CustomMultSelect';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

function Value({
  value,
  label,
  onRemove,
  classNames,
  ...others
}) {
  return (
    <div {...others}>
        <Group
          style={{
            cursor: 'pointer',
            backgroundColor: others.type === 'tenant' ? 'rgb(247, 227, 205)' : '#E3E3FC',
            border: 'none',
            borderRadius: '10px',
            padding: '5px 12px',
          }}
          justify={'center'}
          align={'center'}
          wrap="nowrap"
          gap={8}
        >
          <Group align={'center'} justify={'space-between'} wrap="nowrap" gap={8}>
            <img src={others.type === 'tenant' ? RentIcon : ReceiptsIcon} style={{width: '14px', height: '14px'}} />
            <TruncatedTextHandler className={'transaction-assignment-capsule'} text={others.type === 'tenant' ? `Mietzahlung: ${label}` : `Beleg: ${label}`} maxWidth={others.type === 'tenant' ? 350 : 200}/>
          </Group>
          {<Group align={'center'} justify='right'>
            <CloseButton
              onMouseDown={onRemove}
              variant="transparent"
              size={14}
              iconSize={14}
              tabIndex={-1}
              style={{marginLeft: 8, marginRight: -4}}
            />
          </Group>}
        </Group>
    </div>
  );
}

export class AssignMultipleTransactionsModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    selectedType: null,
    hover1: false,
    hover2: false,
    receiptsList: [],
    receiptsLoader: false,
    selectedReceipts: [],
    selectReceiptsForTransactionAssigmentModalOpen: false,
    rightSectionProps: {
      onClick: ()=> this.setState({selectReceiptsForTransactionAssigmentModalOpen: true})
    },
    addReceiptOpen: false, 
    showModal: false, 
    ImageOpen: false,
    currentRecord: null,
    ReceiptPage: true,
    selectedTransaction: null,
    selectedAssignmentTypeForReceipts: null,
    tenants: [],
    tenantsLoading: true,
    selectedTenant: [],
    dropdownIcon: Down,
    isEarlyRentalPayment: false,
    btnLoader: false,

    openCostTypeMenu: false,
    openTaxCostTypeMenu: false,
    openTaxRateMenu: false,
    customTaxRate: false,
    costTypes: [],
    vatTypes: [
      {label: '19,00 %'},
      {label: '7,00 %'},
      {label: 'anderer'}
    ],
    taxCostTypes: [
    {label: 'Schuldzinsen'},
    {label: 'Geldbeschaffungskosten'},
    {label: 'Erhaltungsaufwendungen'},
    {label: 'Laufende Betriebskosten'},
    {label: 'Verwaltungskosten'},
    {label: 'Sonstige Kosten'},
    {label: 'Erstattete Vorauszahlungen'},
    {label: 'Erhaltene Nachzahlungen'},
    {label: 'Vereinnahmte Kautionen / Mieten aus Vorjahren'},
    {label: 'Vom Finanzamt erstattete Umsatzsteuer'},
    {label: 'Öffentliche Zuschüsse'},
    {label: 'AfA Gebäude'},
    {label: 'AfA bewegliche Wirtschaftsgüter'},
    {label: 'An Finanzamt gezahlte Umsatzsteuer'},
    {label: 'Renten, dauernde Lasten'},
    ],

    utilityBillingCostTypeId: null,
    taxCostType: null,
    taxRate: null,

    stopToggle: false,
    costTypeMenuOptionHover: null,
    heatingCostTypes: [],
    heatingCostType: null
  };
  
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    this.fetchTenants();
    this.getUtilityBillingCostTypes();
  }

  // Fetches rental units + their tenants directly instead of reading state.tenantDataReducer.rentalUnits:
  // that redux slice is populated by whichever page loaded it last, dispatched as soon as the
  // last-*fired* per-rental-unit tenant request resolves rather than the last to actually finish,
  // so it can be caught mid-load with some units still missing tenants.
  fetchTenants = () => {
    const propertyId = this.props.propertySelected?.id;
    if(propertyId === undefined){
      this.finalizeTenants([]);
      return;
    }
    this.setState({tenantsLoading: true});
    GlobalServices._getRentalUnitsByProperty(this, 'handleGetRentalUnitsForTenants', {id: propertyId});
  }

  handleGetRentalUnitsForTenants = (response) => {
    if(response.status && response.statuscode === 200 && response.result?.length > 0){
      this._rentalUnitsWithTenants = response.result.map((ru)=> ({id: ru.id, name: ru.name, tenantsData: []}));
      this._pendingTenantFetches = this._rentalUnitsWithTenants.length;
      this._rentalUnitsWithTenants.forEach((rentalUnit)=>
        GlobalServices._getTenantsByRentalUnitID(this, 'handleGetTenantsForRentalUnit', {rentalUnit})
      );
    }else{
      this.finalizeTenants([]);
    }
  }

  handleGetTenantsForRentalUnit = (response) => {
    const rentalUnit = response.other?.rentalUnit;
    if(rentalUnit && response.status && response.statuscode === 200 && Array.isArray(response.result)){
      rentalUnit.tenantsData = response.result.map((tenant)=> TenantDataHandler.setTenantFormData(tenant, false));
    }
    this._pendingTenantFetches -= 1;
    if(this._pendingTenantFetches <= 0){
      this.finalizeTenants(this._rentalUnitsWithTenants || []);
    }
  }

  finalizeTenants = (rentalUnits) => {
    let tenants = [];
    rentalUnits.forEach((rentalUnit)=> rentalUnit.tenantsData.forEach((tenant)=> {
        if(tenant.vacant === false){
            let noOfMonthBetweenMoveInMoveOut= this.getMonthsBetween(tenant.in, tenant.out.length > 0 ? tenant.out : null);
            tenants.push({...tenant, rentalUnitName: rentalUnit.name, value: tenant.id, label: `${rentalUnit.name}: ${tenant.name} (${tenant.in} - ${tenant.out ? tenant.out : 'aktuell'})`, noOfMonthBetweenMoveInMoveOut});
        }
    }));
    tenants = tenants.sort((a, b) => {
      const extractParts = (name) => {
        const match = name.match(/(\D+)(\d+)?/);
        return [match[1], parseInt(match[2] || "0", 10)];
      };

      const [textA, numA] = extractParts(a.rentalUnitName.toLowerCase());
      const [textB, numB] = extractParts(b.rentalUnitName.toLowerCase());

      if (textA === textB) {
        return numA - numB;
      }

      return textA.localeCompare(textB);
    });
    this.setState({tenants, tenantsLoading: false});
  }

  getMonthsBetween=(dateA, dateB)=> {
    const startDate = dayjs(dateA, 'DD.MM.YYYY');
    const endDate = dateB ? dayjs(dateB, 'DD.MM.YYYY').isAfter(dayjs().add(1, 'M')) ? dayjs().add(1, 'M') : dayjs(dateB, 'DD.MM.YYYY') : dayjs().add(1, 'M');
    const months = [];
    let current = endDate;
    while (current.isAfter(startDate) || current.isSame(startDate, 'month')) {
      months.push({month: current, label: current.format('MMMM YYYY'), value: current.format('MMMM YYYY')}); 
      current = current.subtract(1, 'month');
    }
    return months;
  }

  handleMouseEnter=(type)=>{
    this.setState({[type]: true});
  }

  handleMouseLeave=(type)=>{
      this.setState({[type]: false});
  }

  getReceipts=()=>{
    this.setState({receiptsLoader: true});
    let payload = {
      propertyId: this.props.propertySelected.id,
      includeDetails: false
    }
    GlobalServices._getReceiptsByPropertyWithFilters(this, 'handleGetReceipts', payload);
  }

  handleGetReceipts(response){
    if(response.status && response.statuscode === 200){
        this.setState({receiptsList: response.result.map((receipt)=> ({...receipt, value: receipt.id, label: receipt.name}))});
    }
    this.setState({receiptsLoader: false});  
  }

  getUtilityBillingCostTypes=()=>{
    GlobalServices._getCostTypeByProperty(this, 'handleGetUtilityBillingCostTypes', this.props.propertySelected);
  }

  handleGetUtilityBillingCostTypes(response){
    if(response.status && response.statuscode === 200){
      this.setState({costTypes: response.result.filter((costType)=> costType.useInReceiptMgmt).map((costType)=> ({...costType, label: costType.costTypeName, value: costType.id}))}, ()=> this.getHeatingCostTypes());
    }
  }

  getHeatingCostTypes=()=>{
    GlobalServices._getHeatingCostTypesByProperty(this, 'handleGetHeatingCostTypes', this.props.propertySelected);  
  }

  handleGetHeatingCostTypes(response){
   if(response.status && response.statuscode === 200){
    this.setState({heatingCostTypes: response.result.map((heatingCostTypeObject)=> ({...heatingCostTypeObject, id: heatingCostTypeObject?.id || heatingCostTypeObject?.heatingCostTypeName,  label: heatingCostTypeObject.heatingCostTypeName, value: heatingCostTypeObject?.heatingCostTypeName}))});
   } 
  }

  handleAddReceiptModalOpen=(e)=>{
    this.setState({addReceiptOpen: true});
  }

  handleTransactionAssigments=()=>{
    const {selectedTransactions} = this.props;
    const {selectedType, selectedAssignmentTypeForReceipts} = this.state;
    this.setState({btnLoader: true},()=> {
      if(selectedType === 'CREDIT_DEBIT_BALANCE'){
        this.postBulkReceiptAssignment();
      }else if(selectedType === 'RENTAL_INCOME'){
        this.postBulkRentalPaymentAssignment();
      }else{
        this.setState({btnLoader: false});
      }
    })
    
  }

  postReceiptTenantTransaction=(transactionId, index, selectedReceiptId=null)=>{
    const {propertySelected, selectedTransactions} = this.props;
    const {selectedReceipts, selectedType, selectedTenant} = this.state;
    let payload = selectedType === 'CREDIT_DEBIT_BALANCE' ? 
    {
      transactionId: transactionId,
      receiptIds: selectedReceiptId ? [selectedReceiptId] : selectedReceipts,
      tenantId: null,
      propertyId: propertySelected.id,
      rentalMonth: null
    }
    :
    {
      transactionId: transactionId,
      receiptIds: null,
      tenantId: selectedTenant[0],
      propertyId: propertySelected.id,
      rentalMonth: selectedTransactions.find((selectedTransaction)=> selectedTransaction.id === transactionId)?.bankBookingDate
    };
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + 'ReceiptTenantTransactions',
      'POST',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handlePostReceiptTenantTransaction',
      {type: selectedType === 'CREDIT_DEBIT_BALANCE' ? 'receipt' : 'rent', eol: selectedTransactions.length === (index+1)},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handlePostReceiptTenantTransaction(response){
    if(response.other.eol){
      setTimeout(() => {
        this.setState({btnLoader: false},()=> this.props.toggle(true));  
      }, 2000);
    }
  }

  postReceipt=(transactionId, index)=>{
    const {propertySelected, selectedTransactions} = this.props;
    const {selectedReceipts, selectedType, receiptsList} = this.state;
    let selectedReceipt= receiptsList.find((receipt)=> receipt.id === selectedReceipts[0]);
    const data = JSON.stringify({
      ...selectedReceipt,
      id: null
    });
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.rm_api_base_url + 'create',
      'POST',
      data,
      null,
      false,
      true,
      false,
      this,
      'handlePostReceipt',
      {transactionId, index},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handlePostReceipt(response){
    this.postReceiptTenantTransaction(response.other.transactionId, response.other.index, response?.result);
  }

  postBulkReceiptAssignment=()=>{
    const { propertySelected, selectedTransactions, selectAllTransactions, filters, selectedBankAccount, offset, fetch, searchTransactions} = this.props;
    const { selectedReceipts, selectedAssignmentTypeForReceipts, utilityBillingCostTypeId, taxCostType, taxRate, heatingCostType } = this.state;
    let payload = null;
    if(selectedAssignmentTypeForReceipts === 'assign_one_receipt_for_all'){
      payload = selectAllTransactions ? {
        propertyId: propertySelected?.id,
        receiptIds: selectedReceipts,
        bankAccountId: selectedBankAccount?.id,
        keyword: searchTransactions,
        minimumAmount: filters?.amount?.min,
        maximumAmount: filters?.amount?.max,
        fromDateTime: filters?.bookingDate?.startDate,
        toDateTime: filters?.bookingDate?.endDate,
        isAssigned: typeof filters?.transactionAssignmentFilter === 'boolean' ? filters?.transactionAssignmentFilter : null
      } : {
        propertyId: propertySelected?.id,
        transactionIds: selectedTransactions?.length > 0 ? selectedTransactions.map((transaction)=> transaction?.id) : [],
        receiptIds: selectedReceipts
      };
    }else if(selectedAssignmentTypeForReceipts === 'create_new_receipt_for_all'){
      payload = selectAllTransactions ? {
        propertyId: propertySelected?.id,
        utilityBillingCostTypeId,
        taxCostType,
        taxRate,
        heatingCostType,
        bankAccountId: selectedBankAccount?.id,
        keyword: searchTransactions,
        minimumAmount: filters?.amount?.min,
        maximumAmount: filters?.amount?.max,
        fromDateTime: filters?.bookingDate?.startDate,
        toDateTime: filters?.bookingDate?.endDate,
        isAssigned: typeof filters?.transactionAssignmentFilter === 'boolean' ? filters?.transactionAssignmentFilter : null
      } : {
        propertyId: propertySelected?.id,
        transactionIds: selectedTransactions?.length > 0 ? selectedTransactions.map((transaction)=> transaction?.id) : [],
        utilityBillingCostTypeId,
        taxCostType,
        taxRate,
        heatingCostType
      };
    }

    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + 'receiptTenantTransactions/batch/receipt',
      'POST',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handlePostBulkAssignment',
      {selectedReceipts},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  postBulkRentalPaymentAssignment=()=>{
    const { propertySelected, selectedTransactions, selectAllTransactions, filters, selectedBankAccount, offset, fetch, searchTransactions} = this.props;
    const { selectedReceipts, selectedTenant, isEarlyRentalPayment } = this.state;

    let payload = selectAllTransactions ? {
      propertyId: propertySelected?.id,
      tenantId: selectedTenant[0],
      isEarlyPaymentEnabled: isEarlyRentalPayment,  
      bankAccountId: selectedBankAccount?.id,
      keyword: searchTransactions,
      minimumAmount: filters?.amount?.min,
      maximumAmount: filters?.amount?.max,
      fromDateTime: filters?.bookingDate?.startDate,
      toDateTime: filters?.bookingDate?.endDate,
      isAssigned: typeof filters?.transactionAssignmentFilter === 'boolean' ? filters?.transactionAssignmentFilter : null
    } : {
      propertyId: propertySelected?.id,
      transactionIds: selectedTransactions?.length > 0 ? selectedTransactions.map((transaction)=> transaction?.id) : [],
      tenantId: selectedTenant[0],
      isEarlyPaymentEnabled: isEarlyRentalPayment,  
    };

    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + 'receiptTenantTransactions/batch/tenant',
      'POST',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handlePostBulkAssignment',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handlePostBulkAssignment(response){
    if(response.status && response.statuscode === 200){
      showNotification({
        message: `Beleg${response?.other?.selectedReceipts?.length > 1 ? 'e' : ''} erfolgreich zugeordnet.`,
        icon: <img src={GreenTick} alt={'green-tick'} />
      });

      setTimeout(() => {
        this.setState({btnLoader: false},()=> this.props.toggle(true));  
      }, 2000);
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
        id: 'assignBulkReceiptTransactionError'
      });
    }
  }

  renderMappingRow=()=>{
    const {selectedType, mappings, costTypes, tenants, openCostTypeMenu, taxCostTypes, openTaxCostTypeMenu, openTaxRateMenu, customTaxRate, mappingLoader, openTenantMenu, openIsEarlyPaymentMenu, utilityBillingCostTypeId, taxCostType, taxRate, costTypeMenuOptionHover, heatingCostTypes, heatingCostType} = this.state;
    
    return(
      <Group wrap="nowrap" justify="space-between" style={{width: '100%'}} className='tooltips transaction-mapping-item'>
        <div>
          <span className='transaction-mapping-receipts-text'>
            <span style={{fontWeight: '500'}}>Beleg erzeugen</span> (&nbsp;
              <Menu 
                closeOnItemClick={false}
                withinPortal={true} 
                zIndex={99999} 
                opened={openCostTypeMenu} 
                onChange={(opened) => {
                  if (opened) {
                    this.setState({openCostTypeMenu: true, stopToggle: true});
                  } else {
                    this.setState({openCostTypeMenu: false, stopToggle: false, costTypeMenuOptionHover: null});
                  }
                }}
              >
                <Menu.Target>
                  <div>
                    <TruncatedTextHandler 
                    truncate={true} 
                    alwaysEnableTooltip={true} 
                    maxWidth={120} 
                    alternateTooltipText={utilityBillingCostTypeId ? `Betriebskostenart: ${costTypes.find((costType)=> costType.id === utilityBillingCostTypeId)?.costTypeName} ${costTypes.find((costType)=> costType.id === utilityBillingCostTypeId && costType.costTypeIdentifier === 'HEATING_TOTAL') ? '('+heatingCostTypes.find((heatingCostTypeObject)=> heatingCostTypeObject.heatingCostTypeName === heatingCostType)?.label+')' : ''}` : 'Betriebskostenart: keine Angabe'} 
                    className={costTypes.find((costType)=> costType.id === utilityBillingCostTypeId)?.costTypeName !== undefined ? 'transaction-mapping-capsules-receipts' : 'transaction-mapping-capsules-empty'} 
                    text={costTypes.find((costType)=> costType.id === utilityBillingCostTypeId)?.costTypeName !== undefined ? costTypes.find((costType)=> costType.id === utilityBillingCostTypeId)?.costTypeName : 'Betriebskostenart'}/>
                  </div>
                </Menu.Target>
                
                <Menu.Dropdown style={{maxHeight: '150px', overflowY: 'auto'}}>
                  <Menu.Item 
                    style={{background: utilityBillingCostTypeId === null && '#e6e6ff', fontSize: '12px', fontStyle: 'italic'}} 
                    styles={{itemLabel: {lineHeight: '15px'}}} 
                    onClick={()=> this.setState({utilityBillingCostTypeId: null, costTypeMenuOptionHover: null, heatingCostType: null, openCostTypeMenu: false})}> 
                    keine Angabe
                  </Menu.Item>

                  {costTypes.sort((a,b)=> a?.label?.toLowerCase().localeCompare(b?.label?.toLowerCase())).map((costType)=> (
                    <Menu.Item 
                      key={costType.id}
                      style={{position: 'relative', background: costType.value === utilityBillingCostTypeId && '#e6e6ff', fontSize: '12px', whiteSpace: 'nowrap'}} 
                      styles={{itemLabel: {lineHeight: '15px'}}} 
                      onClick={(e)=> {
                        if (costType.costTypeIdentifier !== 'HEATING_TOTAL') {
                          this.setState({
                            utilityBillingCostTypeId: costType.id, 
                            heatingCostType: null,
                            costTypeMenuOptionHover: null,
                            openCostTypeMenu: false
                          });
                        } else {
                          e.preventDefault();
                          e.stopPropagation();
                          this.setState({costTypeMenuOptionHover: 'HEATING_TOTAL'});
                        }
                      }}
                    >
                      {costType.label}
                      
                      {costType.costTypeIdentifier === 'HEATING_TOTAL' &&
                        <Menu 
                          opened={costTypeMenuOptionHover === 'HEATING_TOTAL'} 
                          onChange={(opened) => {
                            if (opened) {
                              this.setState({stopToggle: true});
                            } else {
                              this.setState({ costTypeMenuOptionHover: null }); 
                              setTimeout(() => {
                                this.setState({ stopToggle: false });
                              }, 150);
                            }
                          }}
                          delay={500} 
                          withinPortal={true} 
                          zIndex={99999} 
                          position="right-start"
                        >
                          <Menu.Target>
                            <div style={{position: 'absolute', right: 0, top: 0, height: '100%', width: '10px'}} />
                          </Menu.Target>
                          <Menu.Dropdown>
                            {heatingCostTypes.map((heatingCostTypeObject)=> (
                              <Menu.Item 
                                key={heatingCostTypeObject.heatingCostTypeName}
                                style={{background: heatingCostType === heatingCostTypeObject.heatingCostTypeName && '#e6e6ff', fontSize: '12px'}} 
                                styles={{itemLabel: {lineHeight: '15px'}}} 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.setState({ 
                                    utilityBillingCostTypeId: costType.id,
                                    heatingCostType: heatingCostTypeObject.heatingCostTypeName,
                                    costTypeMenuOptionHover: null,
                                    openCostTypeMenu: false
                                  });
                                }}
                              >
                                {heatingCostTypeObject.label}
                              </Menu.Item>
                            ))}
                          </Menu.Dropdown>
                        </Menu>
                      }
                    </Menu.Item>
                  ))}
                </Menu.Dropdown>
              </Menu>,&nbsp;

              <Menu 
                withinPortal={true} 
                zIndex={99999} 
                opened={openTaxCostTypeMenu} 
                onChange={(opened) => {
                  if (opened) {
                    this.setState({openTaxCostTypeMenu: true, stopToggle: true});
                  } else {
                    this.setState({openTaxCostTypeMenu: false, stopToggle: false});
                  }
                }}
              >
                <Menu.Target>
                  <div>
                    <TruncatedTextHandler 
                    truncate={true} 
                    alwaysEnableTooltip={true}
                    maxWidth={120} 
                    alternateTooltipText={taxCostType ? `Steuerliche Kostenart: ${taxCostType}` : 'Steuerliche Kostenart: keine Angabe'} 
                    className={taxCostType ? 'transaction-mapping-capsules-receipts' : 'transaction-mapping-capsules-empty'} 
                    text={taxCostType ? taxCostType : 'steuerliche Kostenart'}/> 
                  </div>
                </Menu.Target>
                <Menu.Dropdown style={{maxHeight: '150px', overflowY: 'auto'}}>
                  <Menu.Item style={{background: taxCostType === null && '#e6e6ff', fontSize: '12px', fontStyle: 'italic'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.setState({taxCostType: null})}>keine Angabe</Menu.Item>
                  {taxCostTypes.sort((a, b) => a.label.localeCompare(b.label)).map((tct)=> <Menu.Item key={tct.label} style={{background: tct.label === taxCostType && '#e6e6ff', fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.setState({taxCostType: tct.label})}>{tct.label}</Menu.Item>)}
                </Menu.Dropdown>
              </Menu>,&nbsp;

              {customTaxRate ? 
              <span>
                <NumericFormat 
                className='transaction-mapping-capsules-receipts'
                style={{maxWidth: '44px'}}
                value={taxRate}
                thousandSeparator="." 
                decimalSeparator=","
                suffix={'%'}
                placeholder='0%'
                decimalScale={0}
                onValueChange={(values, sourceInfo) => this.setState({taxRate: values.floatValue})}
                />
              </span>
              :
              <Menu 
                withinPortal={true} 
                zIndex={99999} 
                opened={openTaxRateMenu} 
                onChange={(opened) => {
                  if (opened) {
                    this.setState({openTaxRateMenu: true, stopToggle: true});
                  } else {
                    this.setState({openTaxRateMenu: false, stopToggle: false});
                  }
                }}
              >
                <Menu.Target>
                  <div>
                    <TruncatedTextHandler 
                    truncate={false} 
                    alwaysEnableTooltip={true}
                    maxWidth={120} 
                    alternateTooltipText={taxRate ? `MwSt.-Satz: ${taxRate}` : 'MwSt.-Satz: keine Angabe'} 
                    className={taxRate ? 'transaction-mapping-capsules-receipts' : 'transaction-mapping-capsules-empty'} 
                    text={taxRate ? `${taxRate}%` : 'MwSt.-Satz'}/> 
                  </div>
                </Menu.Target>
                <Menu.Dropdown style={{maxHeight: '150px', overflowY: 'auto'}}>
                    <Menu.Item style={{background: taxRate === null && '#e6e6ff', fontSize: '12px', fontStyle: 'italic'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.setState({taxRate: null})}>keine Angabe</Menu.Item>
                    <Menu.Item style={{background: taxRate === 19 && '#e6e6ff', fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.setState({taxRate: 19})}>19%</Menu.Item>
                    <Menu.Item style={{background: taxRate === 7 && '#e6e6ff', fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.setState({taxRate: 7})}>7%</Menu.Item>
                    <Menu.Item style={{fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.setState({customTaxRate: true})}>Andere</Menu.Item>
                </Menu.Dropdown>
              </Menu>}
              &nbsp;)
          </span>
        </div>
      </Group>
    )
  }
  
  render() {
    const { open, toggle, className, selectedTransactions, selectedBankAccount, filters, selectAllTransactions } = this.props;
    const {selectedType, hover1, hover2, isMobile, receiptsList, selectedReceipts, rightSectionProps, receiptsLoader, addReceiptOpen, showModal, ImageOpen, currentRecord, ReceiptPage, selectedTransaction, selectReceiptsForTransactionAssigmentModalOpen, selectedAssignmentTypeForReceipts, tenants, tenantsLoading, selectedTenant, dropdownIcon, isEarlyRentalPayment, btnLoader, stopToggle} = this.state;
    
    return (
      <CustomModal
        heading={'Beleg zuordnen (Mehrfachaktion)'}
        headingClassName={'multiple-transactions-assignment-modal-heading'}
        open={open}
        toggle={() => {
          if(!stopToggle){
            toggle();
          }
        }}
        className={`${className}`}
        style={{minWidth: !isMobile && '520px'}}
      >
        <Stack gap={20}>
          <Stack gap={0}>
            <Group><span className='add-allocation-sub-headings'>Art der Zahlung</span></Group>
            <SimpleGrid cols={2} style={{margin: '20px 0px 5px'}}>
                  <CardSelection
                  title={'Ausgabe'}
                  subText={'Bei der Zahlung handelt es sich um eine Ausgabe oder Erstattung.'}
                  icon={ReceiptsIcon}
                  blueIcon={ReceiptsIconBlue}
                  hover={hover1}
                  hoverName={'hover1'}
                  selectedType={selectedType}
                  type={'CREDIT_DEBIT_BALANCE'}
                  disabled={btnLoader}
                  onClick={()=> this.setState({selectedType: 'CREDIT_DEBIT_BALANCE', selectedTenant: [], selectedReceipts: []}, ()=> this.getReceipts())}
                  handleMouseEnter={(hoverName)=> this.handleMouseEnter(hoverName)}
                  handleMouseLeave={(hoverName)=> this.handleMouseLeave(hoverName)}
                  isMobile={isMobile}
                  width={'100%'}
                  />
                  <CardSelection
                  title={'Mieteinnahme'}
                  subText={'Bei der Zahlung handelt es sich um eine Mietzahlung.'}
                  icon={RentIcon}
                  blueIcon={RentIconBlue}
                  hover={hover2}
                  hoverName={'hover2'}
                  selectedType={selectedType}
                  type={'RENTAL_INCOME'}
                  disabled={btnLoader}
                  onClick={()=> this.setState({selectedType: 'RENTAL_INCOME', selectedTenant: [], selectedReceipts: []})}
                  handleMouseEnter={(hoverName)=> this.handleMouseEnter(hoverName)}
                  handleMouseLeave={(hoverName)=> this.handleMouseLeave(hoverName)}
                  isMobile={isMobile}
                  width={'100%'}
                  />
            </SimpleGrid>
          </Stack>
          {selectedType === 'CREDIT_DEBIT_BALANCE' &&
          <Stack gap={7}>
            <Stack>
              <Group>
                  <span className='modal-sub-headings'>Zahlungen zuordnen</span>
              </Group>
              <Group className='mb-3'>
                <RadioGroup
                value={selectedAssignmentTypeForReceipts}
                onChange={(value)=> this.setState({selectedAssignmentTypeForReceipts: value})}>
                  <Radio disabled={btnLoader} value='assign_one_receipt_for_all' label={'Alle Zahlungen in einen Beleg zusammenführen.'}/>
                  <Radio disabled={btnLoader} value='create_new_receipt_for_all' label={'Für jede Zahlung einen eigenen Beleg erzeugen.'}/>
                </RadioGroup>
              </Group>
            </Stack>
            {selectedAssignmentTypeForReceipts === 'assign_one_receipt_for_all' &&
            <Stack>
              <Group>
                  <span className='modal-sub-headings'>Beleg zuordnen</span>
              </Group>
              <Group wrap="nowrap" justify="space-between">
                <Group grow style={{width: '100%'}}>
                  <CustomMultiSelect
                    data={receiptsList}
                    value={selectedReceipts}
                    className='multi-select-bank-transactions-receipt-assignment'
                    placeholder="Wählen"
                    disabled={receiptsLoader || btnLoader}
                    onClick={() => {
                      if (!btnLoader) rightSectionProps.onClick();
                    }}
                    valueComponent={(props) => (
                      <Value
                        {...props}
                        type="receipts"
                        onRemove={(e) => {
                          e.stopPropagation();
                          this.setState({ selectedReceipts: selectedReceipts.filter(id => id !== props.value) });
                        }}
                      />
                    )}
                    rightSection={
                      receiptsLoader ? <Loader size={'xs'}/> :
                      <LaunchIcon
                        style={{fontSize: '15px', color: selectedReceipts.length > 0 ? '#5555FF' : '#9A9AB5', cursor: 'pointer'}}
                        onClick={(e)=> {
                          e.stopPropagation();
                          if (!btnLoader) rightSectionProps.onClick();
                        }}
                      />
                    }
                  />
                </Group>
                <IconButton 
                    aria-label="filter list"
                    onClick={this.handleAddReceiptModalOpen}
                    style={{
                    background: '#5655FE',
                    border: '1px solid #5555FF', 
                    boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
                    padding: '5px',
                    cursor: 'pointer',
                    opacity: 1
                    }}>
                      <AddIcon 
                      style={{
                        color: 'white',
                        fontSize: '15px'
                        }}/>
                </IconButton>
              </Group>
            </Stack>}
            {selectedAssignmentTypeForReceipts === 'create_new_receipt_for_all' && this.renderMappingRow()}
          </Stack>}

          {selectedType === 'RENTAL_INCOME' &&
          <Stack>
              <Group>
                  <span className='modal-sub-headings'>Mieter auswählen</span>
              </Group>
              <Group grow>
                <CustomMultiSelect
                  data={tenants}
                  value={selectedTenant}
                  label={'Mieter'}
                  onChange={(newValues) => this.setState({selectedTenant: newValues.length > 0 ? [newValues[newValues.length - 1]] : []})}
                  rightSection={tenantsLoading ? <Loader size={'xs'}/> : <img src={dropdownIcon} alt="dropdown" />}
                  className='multi-select-bank-transactions-receipt-assignment'
                  placeholder="Suche nach Mieter oder Mieteinheit"
                  searchable={true}
                  onClick={() => !tenantsLoading && tenants.length === 0 &&
                    showNotification({
                      message: 'Es wurden noch keine Mieter angelegt.',
                      icon: <img src={RedCross} alt='red-cross'/>
                    })
                  }
                  disabled={btnLoader || tenantsLoading}
                  valueComponent={(props) => (
                    <Value
                      {...props}
                      type="tenant"
                    />
                  )}
                />
              </Group>
              <Group>
                  <span className='modal-sub-headings'>Zahlungsweise</span>
              </Group>
              <Group grow>
                  <SwitchContainer
                  switchText={<span>Mietzahlungen, die in den letzten 5 Tagen eines Monats eingehen, für den Folgemonat berücksichtigen</span>}
                  checked={isEarlyRentalPayment}
                  onChange={()=> this.setState({isEarlyRentalPayment: !isEarlyRentalPayment})}
                  disabled={selectedType === 'CREDIT_DEBIT_BALANCE' || btnLoader}
                  textClassName={'multiple-transaction-is-early-rental-payment-switch-label'}
                  />
              </Group>
          </Stack>}

          <Group justify="space-between">
              <div>
                  <ColorButton
                  text={'Abbrechen'}
                  className='gray-btn'
                  disabled={btnLoader}
                  onClick={()=> toggle()}
                  />
              </div>
              <div>
                  <ColorButton
                  text={'Speichern'}
                  className='purple-btn'
                  showLoader={btnLoader}
                  onClick={()=> this.handleTransactionAssigments()}
                  disabled={selectedType ? (selectedType === 'CREDIT_DEBIT_BALANCE' ? (!selectedAssignmentTypeForReceipts ? true : (selectedAssignmentTypeForReceipts === 'assign_one_receipt_for_all' && selectedReceipts?.length === 0) ? true : false) : selectedType === 'RENTAL_INCOME' ? selectedTenant.length === 0 : false) : true}
                  />
              </div>
          </Group>
        </Stack>

        {addReceiptOpen && (
        <ReceiptDetailModal
          history={this.props.history}
          record={null}
          receiptPage={ReceiptPage}
          parent={this}
          className="add-edit-receipt-modal"
          edit={false}
          open={addReceiptOpen}
          toggle={(newAddedReceipt)=> {
            if(newAddedReceipt){
              this.setState({addReceiptOpen: false, selectedReceipts: [...selectedReceipts, newAddedReceipt.id]}, ()=> this.getReceipts());
            }else{
              this.setState({addReceiptOpen: false});
            }
            
          }}
          isMobile={isMobile}
          transactionAssigment={{amount: selectedTransactions.reduce((partialSum, a) => partialSum + a?.amount, 0), bankBookingDate: dayjs().format(), purpose: null, counterpartName: null}}
        />
        )}
        {showModal &&
        <ShowModal
          onExpansionClick={()=> this.setState({ImageOpen: true})}
          record={currentRecord}
          className="show-receipt-modal"
          open={showModal}
          history={this.props.history}
          transactionAssigment={true}
          closeShow={()=> this.setState({showModal: false, currentRecord: null})}
        />}
        {ImageOpen &&
        <ImageModal
          img={currentRecord && currentRecord.file_name !== '' ? currentRecord.file_name : Receipt}
          className="expandImageModal"
          open={ImageOpen}
          toggle={()=> this.setState({ImageOpen: false})}
        />}
        {selectReceiptsForTransactionAssigmentModalOpen &&
        <SelectReceiptsForTransactionAssigmentModal
        open={selectReceiptsForTransactionAssigmentModalOpen}
        toggle={()=> this.setState({selectReceiptsForTransactionAssigmentModalOpen: false})}
        selectedReceiptsFromParent={selectedReceipts}
        selectedTransaction={{amount: selectedTransactions.reduce((partialSum, a) => partialSum + a?.amount, 0), bankBookingDate: dayjs().format(), purpose: null, counterpartName: null}}
        saveSelectedReceipts={(selectedReceipts)=> this.setState({selectedReceipts, selectReceiptsForTransactionAssigmentModalOpen: false})}
        getReceipts={(newAddedReceipt)=> {
          if(newAddedReceipt){
            this.setState({selectedReceipts: [...selectedReceipts, newAddedReceipt.id]}, ()=> this.getReceipts());
          }else{
            this.getReceipts();
          }
        }}
        />} 
      </CustomModal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
    accountData: state.generalReducer.accountData
  };
};

export default connect(mapStateToProps)(AssignMultipleTransactionsModal);